<app-modal-frame
  [headerText]="CONST.HEADER"
  [rightButton]="{
    type: BUTTON_TYPES.NONE,
  }"
  [leftButton]="{
    type: BUTTON_TYPES.NONE,
  }"
  (emitExit)="onClose()"
>
  <div class="uld-count-modal-container">
    <div class="uld-count-card">
      <ion-row>
        <ion-col
          [formGroup]="uldCountForm"
          size="7"
          class="custom-col ion-padding"
        >
          <div class="sort-date-picker-container">
            <p class="date-label">
              {{ CONST.CLOSE_DATE }} <span class="required-field">*</span>
            </p>
            <app-form-date-picker
              [icon]="SRC.CALENDAR"
              [placeholder]="CONST.SELECT_DATE"
              [minDate]="minDate"
              [maxDate]="maxDate"
              formControlName="closeDate"
            ></app-form-date-picker>
          </div>
          <div class="close-time">
            <app-form-time-picker
              [headerText]="CONST.CLOSE_TIME"
              [required]="true"
              [form]="uldCountForm"
              [control]="'closeTime'"
              [defaultStartTime]="defaultCloseTime"
            ></app-form-time-picker>
          </div>
          <div class="percent-full">
            <app-form-input-field
              [label]="CONST.PERCENT_FULL"
              [required]="true"
              [maxLength]="3"
              [regexType]="SpecialCharacters.NUMBER_ONLY"
              formControlName="percentFull"
            >
            </app-form-input-field>
          </div>
          <div class="btn-container">
            <ion-button
              class="submit-btn"
              [disabled]="uldCountForm.invalid"
              (click)="submit()"
              onkeydown="submit()"
            >
              {{ CONST.SUBMIT }}
            </ion-button>
          </div>
        </ion-col>
        <!-- Icons -->
        <ion-col
          size="5"
          class="top-icons ion-no-padding action-btn-column ion-padding"
        >
          <!-- -->
          <ion-button
            [disabled]="!selection.selected.length"
            [ngClass]="{
              'active-clear-btn': selection.selected.length,
            }"
            class="key-update-btn"
            (click)="loadKeyUpdate()"
            onkeydown="loadKeyUpdate()"
            [fill]="'outline'"
          >
            {{ CONST.LOAD_KEY_UPDATE }}
          </ion-button>
        </ion-col>
      </ion-row>

      <div class="uld-count-table-container">
        <app-table
          [maxHeight]="37"
          [displayedColumns]="displayedColumn"
          [columns]="COLUMN_CONFIG"
          [data]="tableData"
          [customHeader]="customHeader"
          [customColumn]="customColumn"
          #childTable
        >
        </app-table>
        <!-- Table Custom Header -->
        <ng-template
          #customHeader
          let-columnConfig="columnConfig"
          let-columnItem="columnItem"
          let-index="index"
        >
          @switch (columnConfig?.key) {
            @case (ColumnIds.ULD_NUMBER) {
              <ion-row class="th-text">
                <ion-item lines="none" class="item">
                  <ion-checkbox
                    slot="start"
                    class="checkbox"
                    [checked]="selection.hasValue() && isAllSelected()"
                    (ionChange)="$event ? masterToggle() : null"
                  ></ion-checkbox>
                  <ion-label class="checkbox-label">{{
                    ColumnText.ULD_NUMBER
                  }}</ion-label>
                </ion-item>
              </ion-row>
            }
          }
        </ng-template>
        <!-- Table Custom Body -->
        <ng-template
          #customColumn
          let-columnItem="columnItem"
          let-columnConfig="columnConfig"
          let-index="index"
        >
          @switch (columnConfig?.key) {
            @case (index == 0 && ColumnIds.ULD_NUMBER) {
              <ion-radio-group
                [(ngModel)]="selectedUldNumberIndex"
                class="radio-group"
              >
                <ion-item lines="none" class="item">
                  <ion-radio
                    slot="start"
                    [value]="index"
                    class="radio-btn"
                  ></ion-radio>
                  <!-- (click)="openOutboundPopup(activeCarryOverLoads)"
                  onkeydown="openOutboundPopup(activeCarryOverLoads)" -->
                  <ion-label class="btn-label">{{
                    columnItem.uldNumber
                  }}</ion-label>
                </ion-item>
              </ion-radio-group>
            }
            @case (index !== 0 && ColumnIds.ULD_NUMBER) {
              <ion-item lines="none" class="item checkbox-item-container">
                <ion-checkbox
                  slot="start"
                  onkeypress="$event.stopPropagation()"
                  (click)="$event.stopPropagation()"
                  (ionChange)="$event ? selection.toggle(columnItem) : null"
                  [checked]="selection.isSelected(columnItem)"
                  class="checkbox"
                ></ion-checkbox>
                <ion-label class="btn-label">{{
                  columnItem.uldNumber
                }}</ion-label>
              </ion-item>
            }
            @case (ColumnIds.ULD_PKG_COUNT) {
              <div class="pkg-count-wrapper ion-text-center">
                {{ columnItem.uldCount }} / {{ columnItem.pkgCount }}
              </div>
            }
            @case (ColumnIds.ORIG_SORT) {
              {{
                columnItem.origSort.length == 2
                  ? columnItem.origSort
                  : columnItem.origSort + (columnItem?.origSortQual || "")
              }}
            }
          }
        </ng-template>
      </div>
    </div>
  </div>
</app-modal-frame>
